import Vue from 'vue'
import Vuex from 'vuex'
Vue.use( Vuex )
const store = new Vuex.Store( {
  state: {
    altogether:[],
    jyzt:'--',
    oldJlrItem:{},
  },
  
  mutations: {
    updateAltogether(state, data) {
      state.altogether = data;
    },
    updateJyzt(state, data) {
      state.jyzt = data;
    },
    updateOldJlr(state, data) {
      state.oldJlrItem = data;
    }
  }
} )

export default store
